import { render } from "./SearchSchools.vue?vue&type=template&id=337906c4&scoped=true&ts=true"
import script from "./SearchSchools.vue?vue&type=script&lang=ts"
export * from "./SearchSchools.vue?vue&type=script&lang=ts"

import "./SearchSchools.vue?vue&type=style&index=0&id=337906c4&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337906c4"]])

export default __exports__